import { useI18n } from '../lib/i18n';

export function Logo({ compact = false }: { compact?: boolean }) {
  const { t } = useI18n();
  return (
    <div className="brand" aria-label={t('appTitle')}>
      <svg className="brand-mark" viewBox="0 0 42 42" role="img" aria-hidden="true">
        <path d="M21 2 38 11.5v19L21 40 4 30.5v-19L21 2Z" fill="currentColor" />
        <path d="M14 11v20h15v-5H20V11h-6Z" fill="#fff" />
        <circle cx="28.5" cy="14.5" r="3.5" fill="#f4c430" />
      </svg>
      {!compact && <span><strong>LAS PALMAS</strong><small>{t('brandIdentity')}</small></span>}
    </div>
  );
}
